import * as React from 'react';

export const IconPartSelection = (props: React.SVGProps<SVGSVGElement>) => (
	<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={0.5}
			d="M14.8,9.1l-1.6,0.2c-0.2,0-0.4,0.2-0.4,0.4V10c0,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0,0l1.6-0.1
		c0.2,0,0.4-0.2,0.4-0.5V9.2C15,9.1,14.9,9.1,14.8,9.1C14.9,9.1,14.8,9.1,14.8,9.1L14.8,9.1L14.8,9.1z M5.2,9.1l1.6,0.2
		c0.2,0,0.4,0.2,0.4,0.4V10c0,0.1,0,0.1-0.1,0.1c0,0,0,0,0,0L5.5,10C5.2,10,5,9.8,5,9.6V9.2C5,9.1,5.1,9.1,5.2,9.1
		C5.2,9.1,5.2,9.1,5.2,9.1L5.2,9.1L5.2,9.1z M6,8.2c-0.1,0-0.1-0.1-0.1-0.1l1.2-1.6c0-0.1,0.1-0.1,0.2-0.1c1.8-0.1,3.6-0.1,5.4,0
		c0.1,0,0.2,0,0.2,0.1l1.2,1.6c0,0.1,0,0.1-0.1,0.1C11.4,8.1,8.7,8.1,6,8.2L6,8.2L6,8.2z M7.2,5.9C7,5.9,6.9,6,6.8,6.1l-1,1.3H4.6
		c-0.1,0-0.3,0.1-0.3,0.2L4.1,8c0,0.1,0,0.1,0.1,0.1l0.7,0.3L4.6,8.8C4.4,9,4.3,9.3,4.4,9.6V13c0,0.1,0.1,0.2,0.3,0.3h1.8
		c0.1,0,0.2-0.1,0.3-0.3v-0.3h6.6V13c0,0.1,0.1,0.2,0.3,0.3h1.8c0.1,0,0.2-0.1,0.3-0.3V9.6c0-0.3-0.1-0.6-0.2-0.8l-0.3-0.3l0.7-0.3
		c0.1,0,0.1,0,0.1-0.1l-0.1-0.4c0-0.1-0.2-0.2-0.3-0.2h-1.2l-1-1.3C13.2,6,13,5.9,12.9,5.9C11,5.8,9.1,5.8,7.2,5.9L7.2,5.9L7.2,5.9z"
		/>
		<path
			fill="none"
			stroke="currentColor"
			d="M9.9,0.5c5.2,0,9.4,4.2,9.4,9.4c0,5.2-4.2,9.4-9.4,9.4c-5.2,0-9.4-4.2-9.4-9.4c0,0,0,0,0,0
		C0.5,4.7,4.7,0.5,9.9,0.5C9.9,0.5,9.9,0.5,9.9,0.5L9.9,0.5L9.9,0.5z M16.9,17l0.1-0.1c0.6-0.6,1.6-0.6,2.1,0l4.2,4.2
		c-0.3,1.1-1.2,1.9-2.3,2.3l-4.2-4.2C16.3,18.6,16.3,17.6,16.9,17L16.9,17L16.9,17z"
		/>
	</svg>
);
